import { Injectable } from "@angular/core";
import { WhatsappRepo } from "@app/core/whatsapp/domain/whatsapp.repo";
import { SendWhatsappMessageAllPlatforms } from "@app/core/whatsapp/infrastucture/send-whatsapp-message.all-platforms";

import { Observable } from "rxjs";

@Injectable()
export class WhatsappImplRepo implements WhatsappRepo {
  constructor(
    private sendWhatsappMessageAllPlatforms: SendWhatsappMessageAllPlatforms
  ) {}

  sendMessage(message: string, phoneNumber: string): Observable<string> {
    return this.sendWhatsappMessageAllPlatforms.execute(message, phoneNumber);
  }
}
